import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './HighlightedSearch.scss';

/**
 * Reusable HighlightedSearch Component to Render Identified Characters in Values Matching Search
 * @function HighlightedSearch
 * @param {Object}
 * @return {ReactElement}
 */
const HighlightedSearch = ({ commonTextClassName, commonTextStyle, className, style, searchValue, textValue }) => {
  const match = textValue
    .toLowerCase()
    .indexOf(searchValue.toLowerCase());
  const index = match !== -1
    ? match
    : textValue.length;

  return (
    <span className={className} style={style}>
      <span className={commonTextClassName} style={commonTextStyle}>{textValue.substring(0, index)}</span>
      <span className={styles.searchMatch}>{textValue.substring(index, index + searchValue.length)}</span>
      <span className={commonTextClassName} style={commonTextStyle}>
        {textValue.substring(index + searchValue.length)}
      </span>
    </span>
  );
};

HighlightedSearch.propTypes = {
  searchValue: PropTypes.string.isRequired,
  textValue: PropTypes.string.isRequired,
  className: PropTypes.string,
  commonTextClassName: PropTypes.string,
  commonTextStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default HighlightedSearch;
